import React from "react";
import { createRoot } from "react-dom/client";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import { createBrowserHistory } from "history";
import { defineCustomElements } from "@dhl-official/react-library";
import Entry from "./components";
import createStore from "./store";
import ResetStyle from "./styles";
import copy from "./assets/copy/index.json";
import { SESSION_ACCESS_KEY } from "./utils/constants";

const history = createBrowserHistory();

const store = createStore(history, sessionStorage.getItem(SESSION_ACCESS_KEY));
const container = document.getElementById(process.env.MOUNT_ID);
const root = createRoot(container);
root.render(
  <IntlProvider locale="en" messages={copy}>
    <Provider store={store}>
      <ResetStyle />
      <Entry history={history} />
    </Provider>
  </IntlProvider>
);

defineCustomElements();
